import * as React from 'react'
import styled from 'styled-components'
import Tooltip from './Tooltip'
import * as Types from './types'

const UpgradeTooltip = styled(Tooltip)`
  cursor: pointer;
`

export const UPGRADE_TEXT = 'Upgrade to unlock this feature!'

const GateFreeUser: React.FunctionComponent<Types.GateFreeUser> = ({
  onClick,
  point,
}) => (
  <UpgradeTooltip point={point} onClick={onClick}>
    {UPGRADE_TEXT}
  </UpgradeTooltip>
)

export default GateFreeUser



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/GateFreeUser.tsx